/* eslint-disable no-undef */
/**
 * Servicios de SharePoint para el módulo de citas médicas.
 * Adapta las llamadas callback-based de ServicioPnp a Promises,
 * permitiendo consumirlas con async/await en el componente orquestador.
 */
export class SharepointServices {
  constructor() {
    this.pnpService = new ServicioPnp();
  }

  /**
   * Obtiene la configuración de transacciones desde la lista SharePoint.
   * @returns {Promise<object>} Mapa { clave: valor } con la configuración.
   */
  getConfigurations() {
    return new Promise((resolve) => {
      this.pnpService.getListByTitle('configuracionTransacciones', (list) => {
        const configurations = {};
        list.forEach((item) => {
          configurations[item.CSNombreText] = item.CSValorNote;
        });
        resolve(configurations);
      });
    });
  }

  /**
   * Obtiene la configuración de administración de popups desde SharePoint.
   * @returns {Promise<Array>} Lista de configuración de popups.
   */
  getPopupAdministration() {
    return new Promise((resolve) => {
      this.pnpService.getListByTitle(
        'administracionPopups',
        (list) => resolve(list),
        '',
        'Title',
        'Popup',
      );
    });
  }

  /**
   * Obtiene la lista de especialidades configuradas para mostrar en popup.
   * @returns {Promise<Array>}
   */
  getEspecialidadesEnPopup() {
    return new Promise((resolve) => {
      this.pnpService.getListByTitle(
        'especialidadesEnPopup',
        (list) => resolve(list),
        '',
        'Id',
        'Title',
        'Code',
        'Nombre',
        'Descripcion',
      );
    });
  }

  /**
   * Obtiene la lista de sedes configuradas para mostrar en popup.
   * @returns {Promise<Array>}
   */
  getSedesEnPopup() {
    return new Promise((resolve) => {
      this.pnpService.getListByTitle(
        'sedesEnPopup',
        (list) => resolve(list),
        '',
        'Id',
        'Title',
        'Code',
        'Nombre',
        'Descripcion',
        'BranchSAPCode',
      );
    });
  }
}

export const sharepointServices = new SharepointServices();
